export default "__VITE_ASSET__Dt$qneeJ__"